import React from 'react'

import { connect } from 'react-redux'

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

import {
    getPermissions
} from '../actions'

import {
    _getAdmins,
    _postSetAdminPermission,
    _postChangePermission
} from '../../../services'

import {
    Row,
    Button,
    Avatar,
    Icon,
    Checkbox,
    Card,
    Modal,
    Col,
    Popconfirm,
    message
} from 'antd'

class AdminUsers extends React.Component {
    render() {

        const { renderModal, modalVisible, activeAdmin } = this.state

        return (
            <div>
                {renderModal && 
                <Modal
                    title={`${activeAdmin.local.email} settings`}
                    onCancel={this.handleCancelModal}
                    afterClose={this.handleAfterCloseModal}
                    footer={null}
                    centered
                    visible={modalVisible}
                >
                    <div style={{marginBottom: 16}}>
                        <Checkbox
                            onChange={this.toggleSuperuserPermission}
                            checked={activeAdmin.permissions.ezSuperuser}
                        >Superuser</Checkbox>
                    </div>
                    <div>
                        <Popconfirm
                            title="Confirm remove as admin?"
                            onConfirm={this.handleRemoveAdmin}
                        >
                            <Button type="danger">Remove As Admin</Button>
                        </Popconfirm>
                    </div>
                </Modal>}
                <style dangerouslySetInnerHTML={{
                    __html: `

                    .admin-card {
                        position: relative;
                        width: 80px;
                        height: 120px;
                        border: 1px solid #e8e8e8;
                        text-align: center;
                        border-radius: 5px;
                        margin-bottom: 8px;
                        background: white;
                    }

                    .admin-card:hover {
                        cursor: pointer;
                        opacity: 0.8;
                    }

                    .admin-badge {
                        position: absolute;
                        top: -8px;
                        right: -8px;
                        border: 1px solid #ffb800;
                        background: #ffb800;
                        border-radius: 5px;
                        padding: 2px;
                        color: white;
                        font-size: 10px;
                        z-index: 2;
                    }

                    .admin-img {
                        width: 80px;
                        display: flex;
                        height: 80px;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 8px;
                    }

                    .admin-img > img {
                        max-width: 90%;
                        max-height: 90%;
                    }

                    .admin-email {
                        margin-bottom: 14px;
                        // font-size: 1px;
                        display: block;
                    }

                    .admin-name {
                        word-break: break-word;
                        margin: 0px 8px;
                        height: 24px;
                        font-size: 12px;
                        line-height: 12px;
                        overflow: hidden;
                    }

                    .admin-tick {
                        position: absolute;
                        display: inline;
                        top: 40%;
                        left: 42%;
                    }

                    .permission-title {
                        margin-bottom: 12px;
                        font-size: 15px;
                        font-weight: 600;                    
                    }
                `}} />
                <DragDropContext
                onDragEnd={this.onDragEnd}>
                    <Row
                        type="flex"
                        gutter={16}
                    >
                        <Col span={6}>
                            <Card
                                title="Admins"
                                bodyStyle={{
                                    maxHeight: '70vh',
                                    overflowY: 'scroll'
                                }}
                            >
                                <Droppable droppableId="admins">
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                        >
                                            <Row type="flex" gutter={16}>
                                                {this.state.admins.map((_admin, index) => (
                                                    <Draggable
                                                        key={_admin._id}
                                                        draggableId={_admin._id}
                                                        index={index}
                                                    >
                                                        {(provided, snapshot) => (
                                                            <div ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                            >
                                                                <Col>
                                                                    <div 
                                                                    onClick={()=>this.handleOpenModal(_admin)}
                                                                    className="admin-card">
                                                                        {_admin.permissions.ezSuperuser &&
                                                                            <div className="admin-badge">
                                                                                superuser
                                                                            </div>
                                                                        }
                                                                        {_admin.ezPermissionId &&
                                                                            <Icon 
                                                                            style={{fontSize: 20}}
                                                                            type="check-circle" theme="twoTone" twoToneColor="#52c41a" className="admin-tick"/>
                                                                        }
                                                                        <div className="admin-img">
                                                                            {_admin.details.profileImage ?
                                                                                <img src={_admin.details.profileImage} />
                                                                                :
                                                                                <Avatar shape="square" size={0.9 * 80} icon="user" />
                                                                            }
                                                                        </div>
                                                                        <div className="admin-name">
                                                                            {_admin.details.name || _admin.local.email.split('@')[0]}
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                ))}
                                            </Row>
                                        </div>
                                    )}
                                </Droppable>
                            </Card>
                        </Col>
                        <Col
                            style={{ maxHeight: '70vh', overflowY: 'scroll' }}
                            span={18}>
                            {this.props.permissions.map(_permission => (
                                <Droppable
                                    direction="horizontal"
                                    droppableId={_permission._id}>
                                    {(provided, snapshot) => (
                                        <div
                                            style={{
                                                marginBottom: 16
                                            }}
                                            ref={provided.innerRef}
                                        >
                                            <div>
                                                <div className="permission-title">{_permission.title}</div>
                                                <div>
                                                    {this.getAdminsWithPermission(_permission._id).length > 0 ?
                                                        <Row type="flex" gutter={16}>
                                                            {this.getAdminsWithPermission(_permission._id).map(_admin => (
                                                                <Draggable
                                                                    key={`${_admin._id}-${_permission._id}`}
                                                                    draggableId={`${_admin._id}-${_permission._id}`}
                                                                    index={_admin.index}
                                                                >
                                                                    {(provided, snapshot) => (
                                                                        <div ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                        >
                                                                            <Col>
                                                                                <div 
                                                                                onClick={()=>this.handleOpenModal(_admin)}
                                                                                className="admin-card">
                                                                                    {_admin.permissions.ezSuperuser &&
                                                                                        <div className="admin-badge">
                                                                                            superuser
                                                                                        </div>
                                                                                    }
                                                                                    <div className="admin-img">
                                                                                        {_admin.details.profileImage ?
                                                                                            <img src={_admin.details.profileImage} />
                                                                                            :
                                                                                            <Avatar shape="square" size={0.9 * 80} icon="user" />
                                                                                        }
                                                                                    </div>
                                                                                    <div className="admin-name">
                                                                                        {_admin.details.name || _admin.local.email.split('@')[0]}
                                                                                    </div>
                                                                                </div>
                                                                            </Col>
                                                                        </div>
                                                                    )}
                                                                </Draggable>

                                                            ))}
                                                        </Row>
                                                        :
                                                        <div>
                                                            Drag admin name here to assign permission
                                                    </div>
                                                    }
                                                </div>
                                            </div>

                                            {/* {[1,2,3].map((i, index) => (
                                                <Draggable
                                                    key={i}
                                                    draggableId={i}
                                                    index={index}
                                                >
                                                    {(provided, snapshot) => (
                                                        <div ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        >
                                                            {_permission.title}
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))} */}
                                        </div>
                                    )}
                                </Droppable>
                            ))}
                        </Col>
                    </Row>
                </DragDropContext>
            </div>
        )
    }

    constructor(props) {
        super(props)

        this.props.getPermissions()

        this.state = {
            admins: [],
            renderModal: false,
            modalVisible: false
        }
    }

    componentDidMount() {
        _getAdmins()
            .then(res => {
                this.setState({
                    admins: res.data.users
                })
            })
    }

    handleOpenModal = (activeAdmin) => {
        this.setState({
            modalVisible: true,
            renderModal: true,
            activeAdmin
        })
    }

    handleCancelModal = () => {
        this.setState({
            modalVisible: false
        })
    }

    handleAfterCloseModal = () => {
        this.setState({
            activeAdmin: false,
            renderModal: false
        })
    }

    getAdminsWithPermission = (permissionId) => {

        const { admins } = this.state
        
        return admins
                .map( (_admin, index )=> {
                    return ({
                        ..._admin,
                        index
                    })
                })
                .filter(_admin => _admin.ezPermissionId == permissionId)

    }

    onDragEnd = (result) => {

        let { admins } = this.state
        const { source, destination } = result

        if (!destination) {
            return
        }

        _postSetAdminPermission({
            userId: admins[source.index]._id,
            ezPermissionId: destination.droppableId =="admins"? undefined: destination.droppableId
        })
            .then(res => {
                this.setState({
                    admins: [...admins.slice(0, source.index), res.data.user, ...admins.slice(source.index + 1)]
                })
            })

    }

    toggleSuperuserPermission = () => {
        _postChangePermission({unit: 'ezSuperuser', _id: this.state.activeAdmin._id })
        .then(() => {
            this.setState({
                admins: this.state.admins.map( _admin => {
                    
                    if( _admin._id == this.state.activeAdmin._id ){
                        _admin.permissions.ezSuperuser = !_admin.permissions.ezSuperuser
                    }
                    
                    return _admin
                })
            })
        })
        .catch( err => {
            message.error("Only superuser can perform this action!")
        })
    }

    handleRemoveAdmin = () => {
        _postChangePermission({unit: 'ezAdmin', _id: this.state.activeAdmin._id })
        .then(() => {
            this.setState({
                admins: this.state.admins.filter( _admin => _admin._id != this.state.activeAdmin._id )
            })
        })
        .catch( err => {
            message.error("Only superuser can perform this action!")
        })
    }
}

export default connect(
    state => ({
        permissions: state.admins.permissions
    }),
    dispatchEvent => ({
        getPermissions: () => dispatchEvent(getPermissions())
    })
)(AdminUsers)


// WEBPACK FOOTER //
// ./src/components/admin/users/index.js